import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISubCategory } from "../subCategorySlice";

export const getAllSubCategory = createAsyncThunk(
  "SubCategory/FindAllSubCategory",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubCategory/FindAllSubCategory`,
        {
          SubCategory: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching SubCategory:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createSubCategory = createAsyncThunk(
  "SubCategory/InsertSubCategory",
  async (SubCategoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubCategory/InsertSubCategory`,
        SubCategoryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating SubCategory:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSubCategory = createAsyncThunk(
  "SubCategory/UpdateSubCategory",
  async (SubCategoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubCategory/UpdateSubCategory`,
        SubCategoryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating SubCategory :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSubCategory = createAsyncThunk(
  "SubCategory/DeleteSubCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubCategory/DeleteSubCategory`,
        {
          ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting SubCategory :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSubCategoryByID = createAsyncThunk(
  "SubCategory/FindByIDSubCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubCategory/FindByIDSubCategory`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result.Name,
        SubCategoryURL: result.SubCategoryURL,
        CategoryID: result.CategoryID,
        Description: result.Description,
        Image: result.SubCategoryImage,
        IsActive: result.IsActive ? 1 : 2,
      } as ISubCategory;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching SubCategory :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveSubCategory = createAsyncThunk(
  "SubCategory/FindAllActiveSubCategory",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SubCategory/FindAllActiveSubCategory`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching SubCategoryes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const FindAllActiveCategory = createAsyncThunk(
  "Category/FindAllActiveCategory",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Category/FindAllActiveCategory`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching categories:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveSubCategory = createAsyncThunk(
  "SubCategory/ActiveInActiveSubCategory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubCategory/ActiveInActiveSubCategory`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive SubCategory :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);


export const updateSubCategoryImage = createAsyncThunk(
  "SubCategory/SubCategoryImageUpdate",
  async (ClientLogoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubCategory/SubCategoryImageUpdate`,
        ClientLogoData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating client logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);